import { render, staticRenderFns } from "./page-sidebar.vue?vue&type=template&id=15d0e976&scoped=true"
import script from "./page-sidebar.vue?vue&type=script&lang=js"
export * from "./page-sidebar.vue?vue&type=script&lang=js"
import style0 from "./page-sidebar.vue?vue&type=style&index=0&id=15d0e976&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d0e976",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15d0e976')) {
      api.createRecord('15d0e976', component.options)
    } else {
      api.reload('15d0e976', component.options)
    }
    module.hot.accept("./page-sidebar.vue?vue&type=template&id=15d0e976&scoped=true", function () {
      api.rerender('15d0e976', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/client-portal/js/modules/main/components/page-sidebar.vue"
export default component.exports